import { Product } from './types';
import { Users, UserSearch, FileCheck, TrendingUp, Target, Settings, Calendar, Award } from 'lucide-react';

export const recruitmentProducts: Product[] = [
  {
    id: 'recruitment-training-platform',
    title: 'Recruitment Training Platform',
    subtitle: 'Advanced recruitment training and certification',
    description: 'Comprehensive recruitment training solution with skill assessments, learning paths, progress tracking, and certification management for recruitment professionals.',
    icon: Award,
    image: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Recruitment',
    status: 'Available',
    businessTypes: ['#recruitment', '#training', '#hr', '#certification', '#professional-development'],
    features: [
      // Core Recruitment Training (8)
      'Advanced Recruitment Skill Assessments & Competency Testing',
      'Customized Learning Paths for Recruitment Excellence',
      'Real-Time Progress Tracking and Performance Analytics',
      'Professional Certification Management System',
      'Interview Technique Training Modules & Role-Playing',
      'Advanced Sourcing Strategy Courses & Best Practices',
      'Compliance Training Programs & Legal Updates',
      'Performance Benchmarking Tools & Industry Standards',
      
      // Advanced Training Technology (8)
      'AI-Powered Personalized Learning Recommendations',
      'Virtual Reality Interview Simulation Training',
      'Gamification & Interactive Learning Experiences',
      'Social Learning Platform & Peer Collaboration',
      'Mobile Learning App & Microlearning Modules',
      'Video-Based Training & Expert Masterclasses',
      'Assessment Analytics & Skill Gap Identification',
      'Learning Management System Integration',
      
      // Professional Development (8)
      'Career Pathway Planning & Development Roadmaps',
      'Mentorship Program & Expert Coaching',
      'Industry Certification Preparation & Testing',
      'Continuous Professional Development (CPD) Tracking',
      'Leadership Development for Senior Recruiters',
      'Sales Training for Business Development',
      'Technology Training & Software Proficiency',
      'Diversity & Inclusion Training Programs',
      
      // Analytics & Reporting (8)
      'Training ROI Analytics & Business Impact Measurement',
      'Learner Engagement Metrics & Completion Rates',
      'Skills Assessment & Competency Gap Analysis',
      'Training Effectiveness & Performance Correlation',
      'Custom Reporting & Executive Dashboards',
      'Integration with HR & Performance Management Systems',
      'Knowledge Retention Testing & Reinforcement',
      'Training Cost Analysis & Budget Optimization'
    ],
    pricing: { setup: 35000, monthly: 1610 },
    color: 'from-blue-500 to-indigo-600'
  },
  {
    id: 'talent-acquisition-suite',
    title: 'Talent Acquisition Suite',
    subtitle: 'Premium enterprise recruitment platform for talent acquisition professionals',
    description: 'Comprehensive talent acquisition platform combining advanced sourcing, applicant tracking, candidate relationship management, and AI-powered recruitment intelligence. Specifically designed for UK recruitment agencies, enterprise hiring teams, and talent acquisition specialists seeking industry-leading recruitment technology.',
    icon: UserSearch,
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Recruitment',
    status: 'Available',
    businessTypes: ['#talent-acquisition', '#recruitment', '#applicant-tracking', '#hiring', '#candidate-management', '#recruitment-agency', '#enterprise-hiring', '#uk-recruitment', '#global-hiring'],
    features: [
      // Core ATS & Recruitment Excellence (10)
      'Advanced Applicant Tracking System (ATS) with Intelligent CV Parsing',
      'Multi-Channel Talent Sourcing & Advanced Boolean Search Capabilities',
      'Comprehensive Candidate Relationship Management & Talent Pool Building',
      'Intelligent Interview Scheduling & Video Interview Integration',
      'Automated Background Check Integration & Reference Management',
      'Digital Offer Management & Electronic Contract Processing',
      'Seamless Onboarding Process Automation & Documentation Management',
      'Native Integration with Major UK Job Boards, LinkedIn & Reed',
      'Advanced Candidate Assessment & Skills Evaluation Tools',
      'Real-Time Collaboration & Team Performance Management'
    ],
    pricing: { setup: 55000, monthly: 2530 },
    color: 'from-green-500 to-teal-600'
  },
  {
    id: 'recruitment-analytics-platform',
    title: 'Recruitment Analytics Platform',
    subtitle: 'Data-driven recruitment insights',
    description: 'Advanced recruitment analytics platform providing deep insights into hiring performance, candidate quality, and recruitment ROI.',
    icon: TrendingUp,
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Recruitment',
    status: 'Available',
    features: [
      'Recruitment Performance Dashboards',
      'Time-to-Hire Analytics',
      'Quality of Hire Metrics',
      'Source Effectiveness Analysis',
      'Cost-per-Hire Tracking',
      'Diversity & Inclusion Reporting',
      'Predictive Hiring Analytics',
      'Custom KPI Reporting'
    ],
    pricing: { setup: 35000, monthly: 1610 },
    color: 'from-orange-500 to-red-600'
  }
];
